import React from "react";
import Facebook from "../../ui/socials/Facebook";
import Twitter from "../../ui/socials/Twitter";
import Linkedin from "../../ui/socials/Linkedin";
import Whatsapp from "../../ui/whatsapp";
import Tiktok from "../../ui/socials/Tiktok";
import InstagramIcon from "../../ui/socials/Instagram";
import PinterestIcon from "../../ui/socials/Pinterest";
import YoutubeIcon from "../../ui/socials/Youtube";
import SnapchatIcon from "../../ui/Snapchat";

import AmbassadorHelper from "../../utils/AmbassadorHelper";
import {
    Avatar,
    Box,
    Chip,
    Container,
    Link,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";

const getSocialNetworks = (ambassador, dataKey) => {
    const array = [];
    if (ambassador && ambassador.data && dataKey && ambassador.data[dataKey]) {
        const socialHandles = ambassador.data[dataKey];
        Object.entries(socialHandles).forEach((s) => {
            let objectResponse = {};
            objectResponse[s[0]] = s[1];
            if (s[1] !== "" && !s[0].includes("_chat"))
                array.push(objectResponse);
        });
    }
    return array;
};
const cleanName = (networkName) => {
    if (networkName.indexOf("_chat") !== -1) {
        return networkName.replace("_chat", "");
    } else {
        return networkName.replace("_url", "");
    }
};
const getSocialIcon = (socialName) => {
    switch (socialName) {
        case "instagram":
            return <InstagramIcon />;
        case "twitter":
            return <Twitter />;
        case "facebook":
            return <Facebook />;
        case "pinterest":
            return <PinterestIcon />;
        case "snapchat":
            return <SnapchatIcon />;
        case "tiktok":
            return <Tiktok />;
        case "whatsapp":
            return <Whatsapp />;
        case "linkedin":
            return <Linkedin />;
        case "youtube":
            return <YoutubeIcon />;
    }
};

const checkWhatsApp = (url) => {
    const whatsBaseUrl = "https://wa.me/";
    url = url.replace("+", "");
    return url.indexOf(whatsBaseUrl) == -1 ? whatsBaseUrl + url : url;
};
const renderSocials = (value, index) => {
    const fieldName = Object.keys(value)[0];
    const networkName = cleanName(fieldName);
    const link =
        networkName === "whatsapp"
            ? checkWhatsApp(value[fieldName])
            : value[fieldName];
    const sxConfig = {
        marginRight: (theme) => {
            const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
            return isDesktop ? "20px" : "14px";
        },
    };
    return (
        <Link sx={sxConfig} href={link} key={index} target={"_blank"}>
            {getSocialIcon(networkName)}
        </Link>
    );
};

const geHobbies = (ambassador, dataKey) => {
    const hobbiesArray = [];
    if (ambassador && ambassador.data && dataKey && ambassador.data[dataKey]) {
        const hobbiesString = ambassador.data[dataKey];
        if (typeof hobbiesString === "string") {
            hobbiesString.split(",").forEach((hobby) => {
                const trimmedHobby = hobby.trim();
                if (trimmedHobby) {
                    hobbiesArray.push(trimmedHobby);
                }
            });
        }
    }
    return hobbiesArray;
};

const bannerHeigthOptions = {
    mobile: "100px",
    tablet: "205px",
    desktop: "255px",
};

const avatarHeigthOptions = {
    mobile: 150,
    tablet: 150,
    desktop: 212,
    large: 310,
};

const StorefrontHeader = (props) => {
    const theme = useTheme();

    const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const tabletView = useMediaQuery(theme.breakpoints.up("sm"));
    const desktopView = useMediaQuery(theme.breakpoints.up("md"));
    const largeView = useMediaQuery(theme.breakpoints.up("lg"));

    const ambassador = TVSite.ambassadorData;
    const storefront_details =
        AmbassadorHelper.getStoreFrontDetails(ambassador);
    const displayName = AmbassadorHelper.getDisplayName(ambassador);
    const backgroundCover = AmbassadorHelper.getAmbassadorCover(ambassador);
    const socials = getSocialNetworks(ambassador, "social_handles");
    const hobbies = geHobbies(ambassador, "hobbies");
    const getHeigth = () => {
        if (mobileView) return bannerHeigthOptions.mobile;
        if (tabletView && !desktopView) return bannerHeigthOptions.tablet;
        if (desktopView) return bannerHeigthOptions.desktop;
    };

    const getAvatarSize = () => {
        if (mobileView) return avatarHeigthOptions.mobile;
        if (tabletView && !desktopView) return avatarHeigthOptions.tablet;
        if (desktopView) return avatarHeigthOptions.desktop;
        if (largeView && !desktopView) return avatarHeigthOptions.large;
    };

    const bannerHeigth = getHeigth();
    const avatarSize = getAvatarSize();
    const bottomPosition = avatarSize / 2;
    const maxWidthDetails =
        avatarSize === 150 ? "100%" : `calc(100% - ${avatarSize + 10}px)`;

    return (
        <Box
            mt={2}
            sx={{
                width: "100vw",
                margin: "0 auto",
                position: "relative",
                transform: "translateX(-50%)",
                left: "50%",
            }}
        >
            <Box
                backgroundColor="#cccccc"
                width="100%"
                sx={{
                    backgroundImage: `url(${backgroundCover})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    marginBottom: {
                        sm: "0",
                        xs: "75px",
                    },
                }}
                height={bannerHeigth}
                display={"flex"}
            >
                <Container>
                    <Box position="relative" display="flex" height="100%">
                        <Box
                            position={"absolute"}
                            display="flex"
                            sx={{
                                right: {
                                    sm: "0",
                                    xs: "50%",
                                },
                                transform: {
                                    sm: "unset",
                                    xs: "translateX(50%)",
                                },
                            }}
                            bottom={`${-bottomPosition}px`}
                            borderRadius={"50%"}
                        >
                            <Avatar
                                src={AmbassadorHelper.getAmbassadorPhoto(
                                    ambassador
                                )}
                                sx={{
                                    width: `${avatarSize}px`,
                                    height: `${avatarSize}px`,
                                }}
                                alt={displayName}
                            />
                        </Box>
                    </Box>
                </Container>
            </Box>
            <Container>
                <Container maxWidth={maxWidthDetails}>
                    <Box
                        pt={3}
                        pb={2}
                        sx={{
                            width: {
                                sm: "85%",
                                xs: "100%",
                            },
                        }}
                    >
                        <Typography
                            variant={"h1"}
                            textAlign={{ xs: "center", sm: "start" }}
                            fontWeight={700}
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {displayName}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            width: {
                                sm: "85%",
                                xs: "100%",
                            },
                        }}
                    >
                        <Typography
                            fontWeight={400}
                            fontSize={20}
                            textAlign={{ xs: "center", sm: "start" }}
                        >
                            {AmbassadorHelper.getCreatorBio(storefront_details)}
                        </Typography>
                    </Box>
                    <Box pt={tabletView && desktopView ? 3 : 2}>
                        <Box
                            display="flex"
                            justifyContent={{
                                xs: "center",
                                sm: "space-between",
                            }}
                            gap="5px"
                            alignItems={{ xs: "center", sm: "flex-start" }}
                            flexDirection={"column"}
                        >
                            <Box pb={1}>
                                {hobbies.map((hobby, index) => {
                                    const marginLeftValue =
                                        index === 0 ? 0 : "10px";
                                    return (
                                        <Chip
                                            key={index}
                                            sx={{
                                                marginLeft: marginLeftValue,
                                                marginBottom: "24px",
                                                borderRadius: "8px",
                                                border: "1px solid #959499",
                                            }}
                                            variant={"outlined"}
                                            label={
                                                <Typography>{hobby}</Typography>
                                            }
                                        />
                                    );
                                })}
                            </Box>
                            <Box display="flex" mb="5rem">
                                {socials.map(renderSocials)}
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Container>
        </Box>
    );
};

export default StorefrontHeader;
